module.exports = __webpack_public_path__ + "img/sports.1d1b1c2b.svg";